module.exports = __webpack_public_path__ + "img/dashboard-icon.3525772a.svg";